import axios from 'axios';
import config from '../config/common';
import AuthInstance from '../Auth/Auth';
import SetStorageComponent from './storage';

/**
 * [baseURL address to the server api (URL) for production]
 * @type {String}
 */

let baseURL = config.rest_url; // dev server

axios.defaults.baseURL = baseURL;
axios.defaults.timeout = 10000;

axios.interceptors.request.use(async (configuration) => {
  return configuration;
}, (error: any) => { });

axios.interceptors.response.use((response) => {
  return response;
}, (error: any) => {
  if (error && error.response && error.response.status === 401) {
    if (error.response.data && error.response.data.error === 'Unauthorized') {
      const originalRequest = error.config;
      originalRequest._retry = true;
      return AuthInstance.silentAuthentication().then((result: any) => {
        originalRequest.headers.Authorization = 'bearer ' + result.accessToken
        SetStorageComponent('access_token', result.access_token);
        return axios(originalRequest);
      }).catch((err: any) => {
         // if session is expired
         window.location.href = '/logout'
      });
    }
  }
  return Promise.reject(error.response);
});

export const rootURL = baseURL;
export default axios;